import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { huddleProviderPerformanceHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HuddleMetricGrid } from '../HuddleMetricGrid.component'

type ProviderPerformanceBreakdownCardProps = {
  titleHref: string
  providerPerformance: HuddleDashboard['providerPerformanceApi']
  className?: string
}

export function ProviderPerformanceBreakdownCard({
  titleHref,
  providerPerformance,
  className = 'dashboard-huddle-breakdown-card',
}: ProviderPerformanceBreakdownCardProps): React.ReactElement {
  const { gridMetrics, loading, data } = providerPerformance
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleProviderPerformanceHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Provider performance breakdown"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4 }}
      isEmpty={isEmpty}
    >
      <HuddleMetricGrid metrics={gridMetrics} />
    </DashboardSectionCard>
  )
}
